
export const isBarthelScaleKey = (scaleKey) => {
  if (typeof scaleKey !== "string") return false;
  const k = scaleKey.trim().toLowerCase();
  return k === "barthelindex" || k === "barthel";
};

const BARTHEL_KEYS = [
  "feeding",
  "bathing",
  "grooming",
  "dressing",
  "bowels",
  "bladder",
  "toilet_use",
  "transfers",
  "mobility",
  "stairs",
];

export const hasBarthelAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  for (const k of BARTHEL_KEYS) {
    const v = data[k];
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : Number(v);
    // Default is 0; any >0 indicates user input.
    if (Number.isFinite(n) && n > 0) return true;
  }

  return false;
};

